import { ModelInstance, Timescale } from 'src/types/models';

const TIMESCALE_ID_MAP: Record<Timescale, string> = {
  [Timescale.Quarterly]: 'QuarterID',
  [Timescale.Monthly]: 'MonthID',
  [Timescale.Yearly]: 'YearID',
  [Timescale.Weekly]: 'WeekID',
} as const;

type DateIDField = 'Start_DateID' | 'End_DateID';

export const getDateID = (
  modelInstance: ModelInstance,
  date_mapping: Array<Record<string, number>> = [],
  timescale: Timescale | undefined,
  dateField: DateIDField
): number => {
  const modelInstanceTimeScale = modelInstance?.Timescale;
  if (
    !modelInstanceTimeScale ||
    !timescale ||
    modelInstanceTimeScale !== timescale
  ) {
    const selectedMapping = date_mapping.find(
      (m) =>
        m[TIMESCALE_ID_MAP[modelInstanceTimeScale]] ===
        modelInstance?.[dateField]
    );
    return selectedMapping && timescale
      ? selectedMapping[TIMESCALE_ID_MAP[timescale]]
      : modelInstance?.[dateField];
  }
  return modelInstance?.[dateField];
};
